import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/fonts/static/Montserrat-Regular.ttf';
import './assets/fonts/static/Montserrat-Bold.ttf';
import './assets/fonts/static/Montserrat-SemiBold.ttf';
import './assets/fonts/static/Montserrat-Medium.ttf';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
